import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import styled from '@mui/material/styles/styled';
import { useTranslation } from 'react-i18next';
import { useParams, useNavigate } from 'react-router-dom';

import { projectApis } from '../../../apis/projectApis';
import Text from '../../../components/elements/text/Text';
import Title from '../../../components/elements/title/Title';
import { useProject } from '../../../contexts/ProjectContext';
import { useUser } from '../../../contexts/UserContext';
import useToast, { TOAST_TYPE } from '../../../hooks/useToast';
import { buildPath, PRIVATE_ROUTE } from '../../../routes/routes';

const StyledContainer = styled(Container)(({ theme }) => ({
  textAlign: 'center',
  marginTop: theme.spacing(5),
}));

// Page
const ProjectMemberInvitationPage = () => {
  const { t } = useTranslation();
  const { projectId, inviteId } = useParams();
  const { refreshProject } = useProject();
  const { refreshUser } = useUser();
  const navigate = useNavigate();
  const { showToast } = useToast();

  const acceptInvitation = async () => {
    try {
      await projectApis.acceptInvitationProjectMember(projectId, inviteId);
      // refresh project and user to reflect accepted invitation updates.
      await refreshProject();
      await refreshUser();
      navigate(
        buildPath({
          path: PRIVATE_ROUTE.PROJECT_OVERVIEW,
          params: { projectId: projectId },
        })
      );
    } catch (error) {
      showToast(
        TOAST_TYPE.ERROR,
        t('acceptInvitationFailed', { ns: 'notifications' })
      );
    }
  };

  const goBack = () => {
    navigate(PRIVATE_ROUTE.PROJECTS, { replace: true });
  };

  return (
    <StyledContainer>
      <Box sx={{ mt: 2 }}>
        <Title text={t('memberInvitation', { ns: 'project' })} />
        <Text>{t('continueToBeInvited', { ns: 'descriptions' })}</Text>
      </Box>
      <Box sx={{ mt: 2 }}>
        <Button onClick={goBack} variant="outlined" sx={{ mr: 2 }}>
          {t('backToProjectList', { ns: 'buttons' })}
        </Button>
        <Button onClick={acceptInvitation}>
          {t('acceptInvitation', { ns: 'buttons' })}
        </Button>
      </Box>
    </StyledContainer>
  );
};

export default ProjectMemberInvitationPage;
